import gql from 'graphql-tag';

export const GET_ORDER = gql`
  query GetOrder($orderId: ID!) {
    order: Order(id: $orderId) {
      id
      origin
      estimatedFinishTime
      desiredTime

      user {
        id
        name
      }

      payment {
        id
        type
      }
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($orderId: ID!, $status: ORDER_STATUS) {
    updateOrder(id: $orderId, status: $status) {
      id
      status
    }
  }
`;

// Accepts an order
export const ACCEPT_ORDER = gql`
  mutation AcceptPendingOrder($id: ID!, $status: ORDER_STATUS, $estimatedFinishTime: String) {
    updateOrder(id: $id, status: $status, estimatedFinishTime: $estimatedFinishTime) {
      id
      status
    }
  }
`;

// Rejects an order
export const REJECT_ORDER = gql`
  mutation RejectPendingOrder($id: ID!, $rejectReason: String!) {
    setOrderRejected(orderId: $id, rejectReason: $rejectReason) {
      success
      error
      message
    }
  }
`;

export const UPDATE_ORDER_ESTIMATE = gql`
  mutation updateOrderEstimate($id: ID!, $estimatedFinishTime: String) {
    updateOrder(id: $id, estimatedFinishTime: $estimatedFinishTime) {
      id
      estimatedFinishTime
    }
  }
`;

export const GET_PENDING_ORDERS_QUERY = gql`
  query GetPendingOrders($venueId: ID!) {
    venue: Venue(id: $venueId) {
      id
      orders(filter: { status_in: [PENDING] }) {
        id
        status
        createdAt
        type
        comment
        easyId
        origin
        tableId

        estimatedFinishTime
        desiredTime
        remindTimer

        user {
          id
          name
          phone
          language
        }

        payment {
          type
          amount
          correctedTip
        }

        items {
          id
          bundleId
          message
          price {
            amount
            discount
            percentageVAT
          }
          offer {
            id
            name
            nameLang {
              id
              en
              se
              no
              es
            }
          }
          variations {
            id
            name
            highlighted
            asItem {
              id
            }
            tags
            nameLang {
              id
              en
              se
              no
              es
            }
          }
          removedVariations {
            id
            name
            nameLang {
              id
              en
              se
              no
              es
            }
          }
          entry {
            id
            item {
              id
              titleLang {
                id
                en
                se
                no
                es
              }
              categories {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const FULL_ORDER = gql`
  query GetFullOrder($orderId: ID!) {
    order: Order(id: $orderId) {
      id
      status
      createdAt
      type
      comment
      easyId
      origin
      tableId
      estimatedFinishTime
      desiredTime
      remindTimer
      user {
        id
        name
        phone
        language
      }
      payment {
        type
        amount
        correctedTip
      }
      items {
        id
        bundleId
        message
        price {
          amount
          discount
          percentageVAT
        }
        offer {
          id
          name
          nameLang {
            id
            en
            se
            no
            es
          }
        }
        variations {
          id
          name
          highlighted
          asItem {
            id
          }
          tags
          nameLang {
            id
            en
            se
            no
            es
          }
        }
        removedVariations {
          id
          name
          nameLang {
            id
            en
            se
            no
            es
          }
        }
        entry {
          id
          item {
            id
            titleLang {
              id
              en
              se
              no
              es
            }
            categories {
              id
              name
            }
          }
        }
      }
    }
  }
`;
